import React, { Component } from "react";
import BarChartDevices from "../BarChartDevices";
import PieChartOpenTickets from "../PieChartOpenTickets";
import PieChartWarranty from "../PieChartWarranty";
import PieChartServiceType from "../PieChartServiceType";
import config from "@config";
import errorFunctions from "@store/errorFunctions";
import apiEndpoints from "@store/apiEndpoints";
import moment from "moment";
import { IoIosRefreshCircle } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  DeviceReceivedSkeleton,
  ServiceTypesSkeleton,
  TicketStatusCustomSkeleton,
  WarrantyStatusSkeleton,
} from "@components/SkeletonLoading/CustomDashboardSkeleton";
import utilityFunctions from "@store/utilityFunctions";


export default class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      dashboardData: undefined,
      dataChart3: undefined,
      devices: undefined,
      lastUpdated: moment(),
      dateRange: "thisYear",
      brandIdSelected: "",
      startDate: new Date(moment().startOf("year").format("YYYY-MM-DD")),
      endDate: new Date(moment().format("YYYY-MM-DD")),
      isPickDate: true,
      loadingDeviceReceived: false,
      loadingServiceTypes: false,
      loadingTicketStatus: false,
      loadingWarrantyStatus: false,
      errorDeviceReceived: null,
      errorServiceTypes: null,
      errorTicketStatus: null,
      errorWarrantyStatus: null,
      deviceReceivedData: [],
      serviceTypesData: [],
      ticketStatusData: [],
      warrantyStatusData: [],
    };
    this.intervalId = null;
  }

  buildUrl = (endpoint, dateParams = true) => {
    const userBrands = utilityFunctions.getUserInfo()?.user?.brands || [];
    const allBrandIds = userBrands
      .filter((e) => e.country === config.country)
      .map((brand) => brand.id)
      .join(",");

    const roleSCA = this.props.userInfo?.user?.role === "Service Center Admin";
    const serviceCenter = this.props.userInfo?.user?.service_center?.find((s) =>
      s.name.includes("PTC"),
    );

    let url = endpoint;
    const params = [];

    if (dateParams) {
      const date_started = this.state.startDate.toISOString().split("T")[0];
      const date_ended = this.state.endDate.toISOString().split("T")[0];
      params.push(`date_started=${date_started}`);
      params.push(`date_ended=${date_ended}`);
    }

    if (serviceCenter && roleSCA) {
      params.push(`service_center=${serviceCenter.id}`);
    }

    const brandId = this.state.brandIdSelected || allBrandIds;
    if (brandId) {
      params.push(`brand_id=${brandId}`);
    }

    if (params.length > 0) {
      url += "?" + params.join("&");
    }

    return url;
  };

  retrieveDeviceReceivedData = () => {
    this.setState({ loadingDeviceReceived: true, errorDeviceReceived: null });

    const url = this.buildUrl(apiEndpoints.dashboard.numberOfDevice());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          deviceReceivedData: res?.number_of_device_chart || [],
          loadingDeviceReceived: false,
          errorDeviceReceived: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingDeviceReceived: false,
          errorDeviceReceived: "Failed to load device received data",
        });
        console.log("Failed to retrieve device received data", error);
      });
  };

  retrieveServiceTypesData = () => {
    this.setState({ loadingServiceTypes: true, errorServiceTypes: null });

    const url = this.buildUrl(apiEndpoints.dashboard.typeOfServiceTicket());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          serviceTypesData: res?.type_of_service_ticket_chart || [],
          loadingServiceTypes: false,
          errorServiceTypes: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingServiceTypes: false,
          errorServiceTypes: "Failed to load service types data",
        });
        console.log("Failed to retrieve service types data", error);
      });
  };

  retrieveTicketStatusData = () => {
    this.setState({ loadingTicketStatus: true, errorTicketStatus: null });

    const url = this.buildUrl(apiEndpoints.dashboard.openClosedTicket());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          ticketStatusData: res?.open_closed_ticket_chart || [],
          loadingTicketStatus: false,
          errorTicketStatus: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingTicketStatus: false,
          errorTicketStatus: "Failed to load ticket status data",
        });
        console.log("Failed to retrieve ticket status data", error);
      });
  };

  retrieveWarrantyStatusData = () => {
    this.setState({ loadingWarrantyStatus: true, errorWarrantyStatus: null });

    const url = this.buildUrl(apiEndpoints.dashboard.warrantyTicket());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          warrantyStatusData: res?.warranty_ticket_chart || [],
          loadingWarrantyStatus: false,
          errorWarrantyStatus: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingWarrantyStatus: false,
          errorWarrantyStatus: "Failed to load warranty status data",
        });
        console.log("Failed to retrieve warranty status data", error);
      });
  };

  retriveDashboardData(start_date, end_date) {
    this.setState({
      loading: true,
      isPickDate: true,
      loadingDeviceReceived: true,
      loadingServiceTypes: true,
      loadingTicketStatus: true,
      loadingWarrantyStatus: true,
    });

    // let dateRange = "";
    const date_started =
      start_date || new Date(this.state.startDate).toISOString().split("T")[0];
    const date_ended =
      end_date || new Date(this.state.endDate).toISOString().split("T")[0];

    if (date_started > date_ended) {
      alert(
        "Filtering failed. Please check, start date is newer than end date",
      );
      return;
    }

    this.setState(
      {
        lastUpdated: moment(),
        startDate: new Date(start_date || this.state.startDate),
        endDate: new Date(end_date || this.state.endDate),
      },
      () => {
        this.retrieveDeviceReceivedData();
        this.retrieveServiceTypesData();
        this.retrieveTicketStatusData();
        this.retrieveWarrantyStatusData();
      },
    );
  }

  handleOptionsBrandChange = (e) => {
    const { id, value } = e.target;
    this.setState(
      {
        [id]: value,
      },
      () => {
        this.retriveDashboardData();
      },
    );
  };

  handleRangeChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });

    let start_Date = "";
    let end_Date = "";

    switch (value) {
      case "last365":
        start_Date = moment()
          .subtract(365, "days")
          .startOf("day")
          .format("YYYY-MM-DD");
        end_Date = moment().endOf("day").format("YYYY-MM-DD");
        break;
      case "lastYear":
        start_Date = moment()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD");
        end_Date = moment()
          .subtract(1, "year")
          .endOf("year")
          .format("YYYY-MM-DD");
        break;
      case "thisYear":
        start_Date = moment().startOf("year").format("YYYY-MM-DD");
        end_Date = moment().format("YYYY-MM-DD");
        break;
      case "lastMonth":
        start_Date = moment()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        end_Date = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case "thisMonth":
        start_Date = moment().startOf("month").format("YYYY-MM-DD");
        end_Date = moment().format("YYYY-MM-DD");
        break;
      default:
        start_Date = moment().startOf("year").format("YYYY-MM-DD");
        end_Date = moment().format("YYYY-MM-DD");
    }

    if (value !== "custom") {
      this.setState({
        startDate: new Date(start_Date),
        endDate: new Date(end_Date),
      });
      this.retriveDashboardData(start_Date, end_Date);
    }
  };

  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });
    console.log(id + " =" + value);
  };

  componentDidMount() {
    this.retriveDashboardData();
    this.intervalId = setInterval(() => this.retriveDashboardData(), 3600000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  handleDatePickerKeyDown(e) {
    console.log(e.key);
    if (e.key === "Enter") this.retriveDashboardData();
    else this.setState({ isPickDate: false });
  }

  render() {
    return (
      <>
        <div>
          <div className="d-flex flex-row justify-content-between card p-2">
            <div className="d-flex flex-row">
              <div className="m-2">{`Last update: ${this.state.lastUpdated.format(
                "DD-MMM-YYYY HH:mm:ss",
              )}`}</div>
              <button
                title="Refresh"
                className="btn btn-outline-primary btn-sm"
                onClick={() => this.retriveDashboardData()}
              >
                <IoIosRefreshCircle
                  title="Reload data"
                  style={{ fontSize: "1.5rem" }}
                />
              </button>
            </div>

            <div className="d-flex flex-row gap-2">
              <div className="m-2">{"Brand: "}</div>
              <div>
                <select
                  id="brandIdSelected"
                  className="form-select"
                  onChange={this.handleOptionsBrandChange}
                  value={this.state.brandIdSelected}
                >
                  <option value="">All Brands</option>
                  {this.props.userInfo?.user?.brands
                    ? this.props.userInfo?.user?.brands
                        ?.filter((e) => e.country === config.country)
                        .map((brand) => (
                          <option key={brand.id} value={brand.id}>
                            {brand.name}
                          </option>
                        ))
                    : null}
                </select>
              </div>

              <div className="m-2">{"Date Range :"}</div>
              <div>
                <select
                  id="dateRange"
                  className="form-select"
                  onChange={this.handleRangeChange}
                  value={this.state.dateRange}
                >
                  <option value="last365">Last 365 days</option>
                  <option value="lastYear">Last year</option>
                  <option value="thisYear">This year</option>
                  <option value="lastMonth">Last month</option>
                  <option value="thisMonth">This month</option>
                  <option value="custom">Custom</option>
                </select>
              </div>
              <div>
                <DatePicker
                  id="startDate"
                  disabled={this.state.dateRange !== "custom"}
                  className="form-control"
                  selected={new Date(this.state.startDate)}
                  dateFormat="dd/MM/yyyy"
                  onKeyDown={(e) => {
                    this.handleDatePickerKeyDown(e);
                  }}
                  onChange={(val) => {
                    const startDate = val?.toISOString().split("T")[0];
                    const endDate = this.state.endDate
                      .toISOString()
                      .split("T")[0];
                    this.setState({
                      startDate: new Date(startDate),
                    });
                    if (this.state.isPickDate)
                      this.retriveDashboardData(startDate, endDate);
                  }}
                />
              </div>
              <div>
                <DatePicker
                  id="endDate"
                  disabled={this.state.dateRange !== "custom"}
                  className="form-control"
                  selected={new Date(this.state.endDate)}
                  dateFormat="dd/MM/yyyy"
                  onKeyDown={(e) => {
                    this.handleDatePickerKeyDown(e);
                  }}
                  onChange={(val) => {
                    const endDate = val?.toISOString().split("T")[0];
                    const startDate = this.state.startDate
                      .toISOString()
                      .split("T")[0];

                    this.setState({
                      endDate: new Date(endDate),
                    });
                    if (this.state.isPickDate) {
                      this.retriveDashboardData(startDate, endDate);
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* Device Received Chart */}
          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card d-flex align-items-center justify-content-center">
                {this.state.loadingDeviceReceived ? (
                  <DeviceReceivedSkeleton />
                ) : (
                  <>
                    <h6 className="mt-3">Device Received</h6>
                    {this.state.errorDeviceReceived ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorDeviceReceived}
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "80%",
                          padding: "30px",
                        }}
                      >
                        {this.state.deviceReceivedData && (
                          <BarChartDevices
                            data={this.state.deviceReceivedData}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Service Types and Ticket Status */}
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="card d-flex align-items-center justify-content-center">
                {this.state.loadingServiceTypes ? (
                  <ServiceTypesSkeleton />
                ) : (
                  <>
                    <h6 className="mt-3">Service Types</h6>
                    {this.state.errorServiceTypes ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorServiceTypes}
                      </div>
                    ) : (
                      <div style={{ width: "60%" }}>
                        {this.state.serviceTypesData && (
                          <PieChartServiceType
                            data={this.state.serviceTypesData}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="card d-flex align-items-center justify-content-center">
                {this.state.loadingTicketStatus ? (
                  <TicketStatusCustomSkeleton />
                ) : (
                  <>
                    <h6 className="mt-3">Ticket Status</h6>
                    {this.state.errorTicketStatus ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorTicketStatus}
                      </div>
                    ) : (
                      <div style={{ width: "60%" }}>
                        {this.state.ticketStatusData && (
                          <PieChartOpenTickets
                            type="pie"
                            data={this.state.ticketStatusData}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Warranty Status */}
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="card d-flex align-items-center justify-content-center">
                {this.state.loadingWarrantyStatus ? (
                  <WarrantyStatusSkeleton />
                ) : (
                  <>
                    <h6 className="mt-3">Warranty Status</h6>
                    {this.state.errorWarrantyStatus ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorWarrantyStatus}
                      </div>
                    ) : (
                      <div style={{ width: "60%" }}>
                        {this.state.warrantyStatusData && (
                          <PieChartWarranty
                            data={this.state.warrantyStatusData}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
